'use strict';

module.exports = require('./components/DisqusThread');


//////////////////
// WEBPACK FOOTER
// ./~/react-disqus-comments/build/main.js
// module id = 510
// module chunks = 112254247690605